(() => {
  const root=document.querySelector('[data-bek-faq-page]'); if(!root)return;
  const items=[...root.querySelectorAll('[data-faq-item]')];
  const buttons=[...root.querySelectorAll('[data-faq-filter]')];
  const search=root.querySelector('[data-faq-search]');
  const clear=root.querySelector('[data-faq-clear]');
  const count=root.querySelector('[data-faq-count]');
  const empty=root.querySelector('[data-faq-empty]');
  let category='all';
  const norm=(v)=>String(v||'').toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  function apply(){
    const term=norm(search?.value).trim(); let visible=0;
    items.forEach(item=>{
      const cat=item.dataset.category||'';
      const matchesCat=category==='all'||cat===category;
      const matchesTerm=!term||norm(item.dataset.search).includes(term);
      item.hidden=!(matchesCat&&matchesTerm);
      if(!item.hidden)visible++;
    });
    if(count)count.textContent=String(visible);
    if(empty)empty.hidden=visible!==0;
    if(clear)clear.hidden=!term;
  }
  buttons.forEach(btn=>btn.addEventListener('click',()=>{category=btn.dataset.faqFilter||'all';buttons.forEach(x=>x.classList.toggle('is-active',x===btn));apply();}));
  search?.addEventListener('input',apply);
  clear?.addEventListener('click',()=>{search.value='';search.focus();apply();});
  apply();
})();
